<meta-title i18n>הסיסמה שלך</meta-title>

<div class="auth-page">
  <ui-error [state]="loadState" [ignoreList]="[401, 400]"></ui-error>

  <ng-container *visible="loadState.isCompleted">
    <header class="auth-page-header">
      <h2 i18n>הסיסמה החדשה שלך</h2>
      <p i18n>שמרו את הסיסמה במקום בטוח לכניסה חוזרת</p>
    </header>

    <div class="auth-card">
      <p i18n>
        שלום לך,
        <br />
        סיסמתך למערכת הרישום היא:
      </p>

      <div class="auth-password-display password-font">
        {{ result?.newGeneratedPassword }}
      </div>

      <p class="auth-hint" i18n>
        עליך לשמור את הסיסמא לכניסה חוזרת, מומלץ לצלם או לרשום. שמרו את הסיסמה שלכם במקום בטוח!
      </p>

      <div class="auth-form-actions">
        <div class="auth-submit" *ngIf="result?.canLogin; else generateBack">
          <button mat-raised-button color="primary" type="button" (click)="login()" i18n>
            הכנסו למערכת
          </button>
        </div>
        <ng-template #generateBack>
          <a routerLink="/start" class="auth-secondary-btn auth-secondary-btn--link" i18n>
            חזרה להתחברות
          </a>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <ng-container *visible="loadState.error?.isInvalidToken || loadState.error?.isInvalidModel">
    <header class="auth-page-header">
      <h2 i18n>פג תוקף קישור זה</h2>
    </header>

    <div class="auth-card">
      <p i18n>
        תוקף הקישור לאיפוס הסיסמה שלך פג. על מנת לאפס את הסיסמה שלך עבור לעמוד איפוס הסיסמה.
      </p>

      <div class="auth-form-actions">
        <a routerLink="/reset-process" class="auth-secondary-btn auth-secondary-btn--link" i18n>
          איפוס סיסמה שנשכחה
        </a>
      </div>
    </div>
  </ng-container>
</div>
